import { gql } from "urql";
export const SendChatMessageMutation = gql `
    mutation SendChatMessage($input: ChatMessageSendInput!) {
        chatMessages {
            sendMessage(input: $input) {
                chatMessageId
                chatRoomId
                senderUserId
                threadParentId
                content
                contentText
                isEdited
                isDeleted
                threadReplyCount
                threadLastReplyAt
                senderFirstName
                senderLastName
                senderImageUrl
                isPinned
                createdAt
                updatedAt
            }
        }
    }
`;
export const EditChatMessageMutation = gql `
    mutation EditChatMessage($input: ChatMessageEditInput!) {
        chatMessages {
            editMessage(input: $input) {
                chatMessageId
                chatRoomId
                content
                contentText
                isEdited
                updatedAt
            }
        }
    }
`;
export const DeleteChatMessageMutation = gql `
    mutation DeleteChatMessage($chatMessageId: String!) {
        chatMessages {
            deleteMessage(chatMessageId: $chatMessageId)
        }
    }
`;
export const PinChatMessageMutation = gql `
    mutation PinChatMessage($chatMessageId: String!) {
        chatMessages {
            pinMessage(chatMessageId: $chatMessageId) {
                chatPinId
                chatMessageId
                chatRoomId
                pinnedByUserId
                pinnedAt
            }
        }
    }
`;
export const UnpinChatMessageMutation = gql `
    mutation UnpinChatMessage($chatMessageId: String!) {
        chatMessages {
            unpinMessage(chatMessageId: $chatMessageId)
        }
    }
`;
export const AddChatReactionMutation = gql `
    mutation AddChatReaction($input: ChatReactionInput!) {
        chatMessages {
            addReaction(input: $input)
        }
    }
`;
export const RemoveChatReactionMutation = gql `
    mutation RemoveChatReaction($input: ChatReactionInput!) {
        chatMessages {
            removeReaction(input: $input)
        }
    }
`;
